var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _use;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDustWind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 138.5,
    x2: 224.2,
    y1: 5.1,
    y2: 153.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bec1c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: 77.7,
    x2: 169,
    y1: 96.2,
    y2: 254.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 90,
    x2: 102,
    y1: 185.6,
    y2: 206.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fde68a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fde68a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fde171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "d",
    x1: 174,
    x2: 186,
    y1: 185.6,
    y2: 206.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "e",
    x1: 258,
    x2: 270,
    y1: 185.6,
    y2: 206.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "f",
    x1: 216,
    x2: 228,
    y1: 245.6,
    y2: 266.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "g",
    x1: 300,
    x2: 312,
    y1: 245.6,
    y2: 266.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "h",
    x1: 384,
    x2: 396,
    y1: 245.6,
    y2: 266.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "i",
    x1: 166,
    x2: 178,
    y1: 305.6,
    y2: 326.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "j",
    x1: 250,
    x2: 262,
    y1: 305.6,
    y2: 326.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "k",
    x1: 334,
    x2: 346,
    y1: 305.6,
    y2: 326.4
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "l",
    viewBox: "0 0 348 240"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#a)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 24,
    d: "M267.2 24.3A40 40 0 11296 92H12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#b)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 24,
    d: "M151.2 215.7A40 40 0 10180 148H12"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 196,
    r: 12,
    fill: "url(#c)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 196,
    r: 12,
    fill: "url(#d)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 196,
    r: 12,
    fill: "url(#e)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 256,
    r: 12,
    fill: "url(#f)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 256,
    r: 12,
    fill: "url(#g)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 256,
    r: 12,
    fill: "url(#h)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 316,
    r: 12,
    fill: "url(#i)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 316,
    r: 12,
    fill: "url(#j)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 316,
    r: 12,
    fill: "url(#k)"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    width: 348,
    height: 240,
    transform: "translate(83 136)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustWind);
export default __webpack_public_path__ + "static/media/dust-wind.a0b5494336bca62d722c3f3f0282387a.svg";
export { ForwardRef as ReactComponent };